import React from "react";
import { StyleSheet } from "react-native";
import { View } from "~/components/View";
import { styleConstants as C } from "~/style/styleConstants";

const S = StyleSheet.create({
  spacingExtraSmall: {
    width: C.spacingExtraSmall,
    height: C.spacingExtraSmall,
  },
  spacingSmall: { width: C.spacingSmall, height: C.spacingSmall },
  spacingMedium: { width: C.spacingMedium, height: C.spacingMedium },
  spacingLarge: { width: C.spacingLarge, height: C.spacingLarge },
  spacingExtraLarge: {
    width: C.spacingExtraLarge,
    height: C.spacingExtraLarge,
  },
  spacingExtraExtraLarge: {
    width: C.spacingExtraExtraLarge,
    height: C.spacingExtraExtraLarge,
  },
});

export interface SpacerProps {
  /** extraSmall=4 | small=8 | medium=12 | large=16 | extraLarge=24 | extraExtraLarge=32 */
  extraSmall?: boolean;
  /** extraSmall=4 | small=8 | medium=12 | large=16 | extraLarge=24  | extraExtraLarge=32 */
  small?: boolean;
  /** extraSmall=4 | small=8 | medium=12 | large=16 | extraLarge=24  | extraExtraLarge=32 */
  medium?: boolean;
  /** extraSmall=4 | small=8 | medium=12 | large=16 | extraLarge=24   | extraExtraLarge=32 */
  large?: boolean;
  /** extraSmall=4 | small=8 | medium=12 | large=16 | extraLarge=24 | extraExtraLarge=32 */
  extraLarge?: boolean;
  /** extraSmall=4 | small=8 | medium=12 | large=16 | extraLarge=24 | extraExtraLarge=32 */
  extraExtraLarge?: boolean;
}

export const Spacer = ({
  small,
  medium,
  large,
  extraLarge,
  extraSmall,
  extraExtraLarge,
}: SpacerProps) => {
  let style = S.spacingMedium;
  if (extraSmall) style = S.spacingExtraSmall;
  if (small) style = S.spacingSmall;
  else if (medium) style = S.spacingMedium;
  else if (large) style = S.spacingLarge;
  else if (extraLarge) style = S.spacingExtraLarge;
  else if (extraExtraLarge) style = S.spacingExtraExtraLarge;

  return <View style={style} />;
};
